const model = {
    submitting: false,
    errors: null,
    groupDetails: null,
    success: false,
};

export default model;
